/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, total: NonNullable<unknown> }} Table_Pagination_Pageof1Inputs */

const id_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Halaman ${i?.page} dari ${i?.total}`)
};

const ms_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Halaman ${i?.page} daripada ${i?.total}`)
};

const da_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Side ${i?.page} af ${i?.total}`)
};

const de_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seite ${i?.page} von ${i?.total}`)
};

const en_us2_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.total}`)
};

const es_es2_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page} de ${i?.total}`)
};

const es_mx2_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page} de ${i?.total}`)
};

const fil_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pahina ${i?.page} ng ${i?.total}`)
};

const fr_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} sur ${i?.total}`)
};

const it_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pagina ${i?.page} di ${i?.total}`)
};

const hu_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.page}. oldal / ${i?.total}`)
};

const nl_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pagina ${i?.page} van ${i?.total}`)
};

const no_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Side ${i?.page} av ${i?.total}`)
};

const pl_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Strona ${i?.page} z ${i?.total}`)
};

const pt_br2_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.total}`)
};

const pt_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page} de ${i?.total}`)
};

const ro_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pagina ${i?.page} din ${i?.total}`)
};

const fi_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sivu ${i?.page} / ${i?.total}`)
};

const sv_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sida ${i?.page} av ${i?.total}`)
};

const vi_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trang ${i?.page} / ${i?.total}`)
};

const tr_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sayfa ${i?.page} / ${i?.total}`)
};

const cs_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stránka ${i?.page} z ${i?.total}`)
};

const bg_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Страница ${i?.page} от ${i?.total}`)
};

const ru_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Страница ${i?.page} из ${i?.total}`)
};

const uk_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сторінка ${i?.page} з ${i?.total}`)
};

const ar_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`صفحة ${i?.page} من ${i?.total}`)
};

const hi_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`पृष्ठ ${i?.page} का ${i?.total}`)
};

const th_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`หน้า ${i?.page} จาก ${i?.total}`)
};

const ja_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.page} / ${i?.total} ページ`)
};

const zh_cn2_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.total}`)
};

const zh_hant1_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.total}`)
};

const ko_table_pagination_pageof1 = /** @type {(inputs: Table_Pagination_Pageof1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Page {page} of {total}" |
*
* @param {Table_Pagination_Pageof1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_pagination_pageof1 = /** @type {((inputs: Table_Pagination_Pageof1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Pagination_Pageof1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_pagination_pageof1(inputs)
	if (locale === "ms") return ms_table_pagination_pageof1(inputs)
	if (locale === "da") return da_table_pagination_pageof1(inputs)
	if (locale === "de") return de_table_pagination_pageof1(inputs)
	if (locale === "en-US") return en_us2_table_pagination_pageof1(inputs)
	if (locale === "es-ES") return es_es2_table_pagination_pageof1(inputs)
	if (locale === "es-MX") return es_mx2_table_pagination_pageof1(inputs)
	if (locale === "fil") return fil_table_pagination_pageof1(inputs)
	if (locale === "fr") return fr_table_pagination_pageof1(inputs)
	if (locale === "it") return it_table_pagination_pageof1(inputs)
	if (locale === "hu") return hu_table_pagination_pageof1(inputs)
	if (locale === "nl") return nl_table_pagination_pageof1(inputs)
	if (locale === "no") return no_table_pagination_pageof1(inputs)
	if (locale === "pl") return pl_table_pagination_pageof1(inputs)
	if (locale === "pt-BR") return pt_br2_table_pagination_pageof1(inputs)
	if (locale === "pt") return pt_table_pagination_pageof1(inputs)
	if (locale === "ro") return ro_table_pagination_pageof1(inputs)
	if (locale === "fi") return fi_table_pagination_pageof1(inputs)
	if (locale === "sv") return sv_table_pagination_pageof1(inputs)
	if (locale === "vi") return vi_table_pagination_pageof1(inputs)
	if (locale === "tr") return tr_table_pagination_pageof1(inputs)
	if (locale === "cs") return cs_table_pagination_pageof1(inputs)
	if (locale === "bg") return bg_table_pagination_pageof1(inputs)
	if (locale === "ru") return ru_table_pagination_pageof1(inputs)
	if (locale === "uk") return uk_table_pagination_pageof1(inputs)
	if (locale === "ar") return ar_table_pagination_pageof1(inputs)
	if (locale === "hi") return hi_table_pagination_pageof1(inputs)
	if (locale === "th") return th_table_pagination_pageof1(inputs)
	if (locale === "ja") return ja_table_pagination_pageof1(inputs)
	if (locale === "zh-CN") return zh_cn2_table_pagination_pageof1(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_pagination_pageof1(inputs)
	return ko_table_pagination_pageof1(inputs)
});
export { table_pagination_pageof1 as "table.pagination.pageOf" }